export enum CRUDOperation {
    Create = 'create', Update = 'update', Delete = 'delete'
}